import { render, staticRenderFns } from "./ai-loader.vue?vue&type=template&id=bbfdb002&scoped=true"
import script from "./ai-loader.vue?vue&type=script&lang=js"
export * from "./ai-loader.vue?vue&type=script&lang=js"
import style0 from "./ai-loader.vue?vue&type=style&index=0&id=bbfdb002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfdb002",
  null
  
)

export default component.exports